<template>
	<v-tab-item>
		<v-card flat>
			<h3 class="text-h6 font-weight-bold">情報物件情報</h3>
			<template v-if="orderIndividualInfo">
				<v-row class="mt-4" no-gutters justify="space-between" align="center">
					<h6 class="secondary--text text-body-1 font-weight-bold">基本情報</h6>
					<OrderIndividualInfoEditDialog
						v-if="authorityFlag"
						:id="orderIndividualInfo.id"
						@update-individual-info="updateIndividualInfo($event)"
						@reset-order-individual-info="$emit('reset-order-individual-info')"
					/>
				</v-row>
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<ShowDetailRecord
							:columnName="'製造番号'"
							:value="
								orderIndividualInfo.ordered_product
									? orderIndividualInfo.ordered_product.product_number
									: '未受注'
							"
						/>
						<ShowDetailRecord :columnName="'枝番号'" :value="orderIndividualInfo.sub_number" />
						<ShowDetailRecord :columnName="'個数'" :value="orderIndividualInfo.quantity" />
						<ShowDetailRecord
							:columnName="'製品名'"
							:value="
								orderIndividualInfo.ordered_product
									? orderIndividualInfo.ordered_product.product.name
									: orderIndividualInfo.matter_product.product.name
							"
						/>
						<ShowDetailRecord :columnName="'個数'" :value="orderIndividualInfo.quantity" />
						<ShowDetailRecord :columnName="'状況'" :value="orderIndividualInfo.status_i18n" />
						<ShowDetailRecord
							:columnName="'施工場所'"
							:value="orderIndividualInfo.construction_place"
						/>
						<ShowDetailRecord
							:columnName="'製造開始日'"
							:value="
								common.formatDateWithNullableTime(orderIndividualInfo, 'start_date', 'start_time')
							"
						/>
						<ShowDetailRecord
							:columnName="'製造終了日'"
							:value="
								common.formatDateWithNullableTime(orderIndividualInfo, 'end_date', 'end_time')
							"
						/>
					</tbody>
				</table>
				<v-row class="mt-4" no-gutters justify="space-between" align="center">
					<h6 class="secondary--text text-body-1 font-weight-bold">工程情報</h6>
					<v-btn
						v-if="showProcessBtn && processAuthorityFlag"
						@click="processNewDialog = true"
						color="secondary"
					>
						<v-icon class="mr-1"> mdi-plus </v-icon>
						工程を追加する</v-btn
					>
				</v-row>
				<table
					v-if="orderIndividualInfo.large_processes.length"
					width="100%"
					class="mt-2 show-dialog-table"
				>
					<LargeProcessInfoUnit
						v-for="process in sortedProcesses"
						:key="process.id"
						:large_process="process"
						:showEditBtn="showProcessBtn && processAuthorityFlag"
						@click-edit-btn="setLargeProcessDialog(process)"
					/>
				</table>
				<p v-else class="text-body-2 mt-2">登録された工程はまだありません。</p>
			</template>
		</v-card>
		<template v-if="showProcessBtn && processAuthorityFlag">
			<LargeProcessNewDialog
				:dialog.sync="processNewDialog"
				:requiredIndividualInfo="false"
				:large_process_types="largeProcessTypes"
				:toolbarTitle="'工程追加'"
				:order_individual_info="orderIndividualInfo.id"
				:requiredOrderIndividualInfo="false"
				@create-process="createProcess($event)"
			/>
			<LargeProcessEditDialog
				:dialog.sync="processEditDialog"
				:requiredIndividualInfo="false"
				:large_process_types="largeProcessTypes"
				:toolbarTitle="'工程編集'"
				:large_process="selectedLargeProcess"
				:order_individual_info="orderIndividualInfo.id"
				:requiredOrderIndividualInfo="false"
				@update-large-process="updateLargeProcess($event)"
			/>
		</template>
	</v-tab-item>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
// import LargeProcessEditDialog from "../../large_process/components/LargeProcessEditDialog.vue"
import LargeProcessInfoUnit from "../../large_process/components/LargeProcessInfoUnit.vue"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import OrderIndividualInfoEditDialog from "../components/OrderIndividualInfoEditDialog.vue"
export default {
	props: {
		order_individual_info: {
			type: null,
			required: false,
		},
		authorityFlag: {
			type: Boolean,
			required: false,
			default: false,
		},
		processAuthorityFlag: {
			type: Boolean,
			required: false,
			default: false,
		},
		largeProcessTypes: {
			type: Array,
			required: true,
		},
		showProcessBtn: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	components: {
		ShowDetailRecord,
		LargeProcessInfoUnit,
		OrderIndividualInfoEditDialog,
		LargeProcessNewDialog: () => import("../../large_process/components/LargeProcessNewDialog.vue"),
		LargeProcessEditDialog: () =>
			import("../../large_process/components/LargeProcessEditDialog.vue"),
	},
	data() {
		return {
			largeProcessTypeId: null,
			processNewDialog: false,
			processEditDialog: false,
			infoEditDialog: false,
			selectedLargeProcess: null,
			common,
		}
	},
	methods: {
		setLargeProcessDialog(process) {
			this.selectedLargeProcess = process
			this.processEditDialog = true
		},
		createProcess(process) {
			this.orderIndividualInfo.large_processes.push(process)
			this.$emit('update-info',this.orderIndividualInfo)
		},
		updateLargeProcess(process) {
			const largeProcess = this.orderIndividualInfo.large_processes.find((p) => p.id == process.id)
			const index = this.orderIndividualInfo.large_processes.indexOf(largeProcess)
			let large_processes = this.orderIndividualInfo.large_processes
			large_processes.splice(index, 1)
			large_processes.push(process)
			this.orderIndividualInfo.large_processes = large_processes
			this.$emit("update-info", this.orderIndividualInfo)
		},
		updateIndividualInfo(orderIndividualInfo) {
			this.orderIndividualInfo = orderIndividualInfo
			this.$emit("update-info", this.orderIndividualInfo)
		},
	},
	computed: {
		sortedProcesses() {
			return common.sortDesc(this.orderIndividualInfo.large_processes, "planned_start_date")
		},
		orderIndividualInfo: {
			get() {
				return this.order_individual_info
			},
			set(newVal) {
				return this.$emit("update-info", newVal)
			},
		},
	},
	watch: {},
}
</script>
